// AutoresProduto.js — Seção "Autores" da página de produto (avatar, bio e perfil).
// Usa ebook.autores (formato processado: { id, nome, has_profile, biografia?, image? }).
//
// ================= O QUE O PRINT MOSTROU (17/09/2026) =================
//
// O cartão do autor saía com uns 190px de altura para três linhas de texto, com
// um vão enorme em volta. Não era escolha de desenho: era `p-5`, e o
// bootstrap.min.css declara a MESMA classe com !important e 3rem — 48px de
// respiro em cada lado, contra os 20px que o Tailwind pretendia. A grade tinha
// `gap-5`, com o mesmo problema. Os valores daqui não têm homônimo no Bootstrap
// (`p-[1.125rem]`, `gap-3.5`), e o cartão volta a ter o tamanho do conteúdo.
//
// O título também deixou de ser "Autores:" com dois-pontos, e passou a ser o
// mesmo cabeçalho das outras seções da página (CabecalhoDeSecao).
import React from "react";
import { Link } from "react-router-dom";
import CabecalhoDeSecao from "./CabecalhoDeSecao";
import FotoPessoa from "../../ui/FotoPessoa";

const main = process.env.REACT_APP_MAIN;

const AutoresProduto = ({ autores = [] }) => {
  // Normaliza: aceita objeto {nome,...} ou string legada.
  const lista = autores.map((a) => (typeof a === "object" ? a : { nome: a, has_profile: false }));
  if (lista.length === 0) return null;

  return (
    <section className="mb-12" aria-labelledby="autores-do-livro">
      <CabecalhoDeSecao
        chapeu="Quem escreveu"
        // Singular com um autor só: "Autores" em cima de um cartão único lê
        // como se faltasse gente na lista.
        titulo={lista.length > 1 ? "Autores" : "Autor"}
        id="autores-do-livro"
      />

      <div className="grid grid-cols-1 gap-3.5 md:grid-cols-2">
        {lista.map((autor, i) => {
          const temPerfil = autor.has_profile && autor.id;
          return (
            <div key={autor.id || i} className="cartao flex items-start gap-4 p-[1.125rem]">
              {/* ===== A FOTO (17/09/2026) =====
                  O rosto não aparecia por dois motivos somados: a API nunca
                  mandava a foto do autor na resposta do livro (ver
                  ResolveAutores.php), e este cartão tinha a própria regra de
                  "qual campo é a foto", diferente da do resto do site.
                  FotoPessoa é a regra única — a mesma da página do autor e dos
                  comentários —, e ela ainda resolve a imagem quebrada caindo nas
                  iniciais, em vez de sumir com a <img> e deixar um círculo
                  vazio, que era o que acontecia aqui. */}
              <FotoPessoa pessoa={autor} nome={autor.nome} tamanho="w-16 h-16 text-xl" />
              <div className="min-w-0 flex-1">
                <h3 className="font-bold leading-snug text-white">{autor.nome}</h3>
                {autor.biografia ? (
                  <p className="mt-1 line-clamp-3 text-sm leading-relaxed text-white/60">{autor.biografia}</p>
                ) : (
                  <p className="mt-1 text-sm text-white/40">Autor(a) na Insigne Acadêmica.</p>
                )}
                {temPerfil && (
                  <Link
                    to={`${main}autores/${autor.id}`}
                    onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                    // Link com seta, e não mais um botão cinza: "Ver Autor" num
                    // retângulo cinza ao lado do botão laranja de comprar lia
                    // como uma segunda ação da página, e ele é um atalho.
                    className="foco-laranja group/autor mt-2.5 inline-flex items-center gap-1.5 rounded-controle text-sm font-semibold !text-insigne-orange hover:underline"
                  >
                    Ver perfil e outros livros
                    <i className="bi bi-arrow-right text-xs transition-transform group-hover/autor:translate-x-0.5" aria-hidden="true" />
                  </Link>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default AutoresProduto;
